/* audit_policy.icon.svg.js */

module.exports = {
    icon: `    
            <svg viewBox="0 0 22 20" preserveAspectRatio="none">
              <path d="m17,2.55l-2.3,0a3.46,3.46 0 0 0 -6.63,0l-2.41,0a1.87,1.87 0 0 0 -1.86,1.87l0,14.14a1.87,1.87 0 0 0 1.86,1.87l11.34,0a1.87,1.87 0 0 0 1.87,-1.87l0,-14.14a1.87,1.87 0 0 0 -1.87,-1.87zm-7.84,1.16l0.05,0l0,-0.12a2.15,2.15 0 0 1 0.62,-1.5l0,0a2.31,2.31 0 0 1 0.39,-0.31l0.15,-0.08a2,2 0 0 1 0.34,-0.14l0.14,-0.05a2.25,2.25 0 0 1 0.52,-0.07a1.91,1.91 0 0 1 0.54,0.08l0.12,0a1.57,1.57 0 0 1 0.42,0.18l0.05,0a2.15,2.15 0 0 1 1,1.84l0,0.12l2.52,0c-0.07,0.7 -0.18,2.16 -1.62,2.19l-6.14,0c-1.44,0 -1.55,-1.49 -1.61,-2.19l2.51,0.05z" class="foreground-gl"/>
            </svg>
         `
};
